import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import { STATISTIC, IS_MICRO } from "./constants/conf"
// import "dayjs/locale/zh-cn" // 已配置day.js替换moment, 若需使用 DatePicker, TimePicker, Calendar等日期组件, 可以直接使用, 不必再引入moment
import "./index.css"

var _hmt = _hmt || []
STATISTIC &&
  (function () {
    var hm = document.createElement("script")
    hm.src = "https://hm.baidu.com/hm.js?ab4102ff44d175c1327c9fc5ced5f632"
    var s = document.getElementsByTagName("script")[0]
    s.parentNode.insertBefore(hm, s)
  })()

const domId = "rootBI"

function render(props: any) {
  const { container } = props
  ReactDOM.render(
    <App />,
    container
      ? container.querySelector("#" + domId)
      : document.getElementById(domId)
  )
}

if (!IS_MICRO) {
  render({})
} else {
  // @ts-ignore
  __webpack_public_path__ =
    // @ts-ignore
    window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  render(props)
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {
  ReactDOM.unmountComponentAtNode(document.getElementById(domId))
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props: any) {}

if (module.hot) {
  module.hot.accept()
}
